module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "content-group text-center",
    staticStyle: {
      "margin-bottom": "0!important"
    }
  }, [_c('span', {
    staticClass: "display-inline-block"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.blogItem.image,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "content-group-lg"
  }, [_c('ul', {
    staticClass: "list-inline list-inline-condensed no-margin-bottom"
  }, _vm._l((_vm.blogItem.tags), function(tag) {
    return _c('li', [_c('span', {
      staticClass: "label border-left-blue label-striped content-group"
    }, [_vm._v(_vm._s(tag))])])
  })), _vm._v(" "), _c('h3', {
    staticClass: "text-semibold mb-5 blog-title"
  }, [_c('a', {
    staticClass: "text-default",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.blogItem.title))])]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline list-inline-separate text-muted content-group"
  }, [_c('li', [_vm._v(_vm._s(_vm.formatedDate) + " | Day " + _vm._s(_vm.blogItem.day))])]), _vm._v(" "), (_vm.blogItem.preview && !_vm.showFullPost) ? _c('div', {
    staticClass: "content-group",
    domProps: {
      "innerHTML": _vm._s(_vm.blogItem.preview)
    }
  }) : _c('div', {
    staticClass: "content-group",
    domProps: {
      "innerHTML": _vm._s(_vm.blogItem.content)
    }
  }), _vm._v(" "), (_vm.showFullPost) ? _c('vue-disqus', {
    ref: "disqus",
    attrs: {
      "shortname": "pursuing-business",
      "identifier": _vm.blogItem.id,
      "url": ("https://pursuing.business/post/" + (_vm.blogItem.id))
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "heading-elements-footer"
  }, [(!_vm.showFullPost) ? _c('a', {
    staticClass: "btn btn-primary btn-icon",
    attrs: {
      "type": "button",
      "href": ("https://www.facebook.com/sharer/sharer.php?u=https://pursuing.business/post/" + (_vm.blogItem.id)),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fab fa-facebook-square"
  })]) : _vm._e(), _vm._v(" "), (!_vm.showFullPost) ? _c('a', {
    staticClass: "btn btn-info btn-icon",
    attrs: {
      "type": "button",
      "target": "_blank",
      "href": ("https://twitter.com/intent/tweet?text=Starting%20Business%20from%20Zero:%20" + (encodeURIComponent(_vm.blogItem.title)) + "%0Ahttps://pursuing.business/post/" + (_vm.blogItem.id))
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter-square"
  })]) : _vm._e(), _vm._v(" "), (!_vm.showFullPost) ? _c('a', {
    staticClass: "btn btn-default btn-icon text-muted",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.togglePost
    }
  }, [_c('i', {
    staticClass: "far fa-comment text-size-base text-pink position-left"
  }), _vm._v(" Comments")]) : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.blogItem.owner === _vm.getUser.uid) ? _c('a', {
    staticClass: "btn btn-warning btn-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeItem
    }
  }, [_c('i', {
    staticClass: "fas fa-trash"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "heading-btn pull-right"
  }, [(_vm.blogItem.preview && !_vm.showFullPost) ? _c('a', {
    staticClass: "heading-text pull-right",
    on: {
      "click": _vm.togglePost
    }
  }, [_vm._v("Read more "), _c('i', {
    staticClass: "fas fa-arrow-right position-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.showFullPost) ? _c('a', {
    staticClass: "heading-text pull-right",
    on: {
      "click": _vm.togglePost
    }
  }, [_vm._v("Hide "), _c('i', {
    staticClass: "fas fa-angle-up position-right"
  })]) : _vm._e()])])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c61c420","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/BlogItem.vue
// module id = 357
// module chunks = 0